var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M15 4.85596L7 12.856L15 20.856","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])}
var staticRenderFns = []

export { render, staticRenderFns }